"use strict";

module.exports = function () {
       return this.opts.filterable && this.opts.filterable.length ? this.opts.filterable : this.Columns;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/filterable-columns.js